import { breakpoints } from '@/themes/themeOverrides/Breakpoints';
import { Palette } from '@/themes/themeOverrides/Palette';

/** Sticky last column is always on when enabled; shadow gradient only when table overflows horizontally. */
export const getStickyLastColumnSx = (enabled, showShadow) => {
    if (!enabled) {
        return {};
    }

    return {
        '& .RaDatagrid-table': {
            position: 'relative',
            '& td:last-child, & th:last-child': {
                position: 'sticky',
                right: 0,
                zIndex: 2,
                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                    width: '80px',
                },
                '&.MuiTableCell-head': {
                    '&::after': {
                        background: `${Palette.gray.gray100} !important`,
                    },
                },
                ...(showShadow
                    ? {
                          '&::before': {
                              content: '""',
                              position: 'absolute',
                              top: 0,
                              left: '-12px',
                              width: '12px',
                              height: '100%',
                              background: 'linear-gradient(to right, transparent, rgba(0, 0, 0, 0.03))',
                              pointerEvents: 'none',
                          },
                          '&.MuiTableCell-root': {
                              '&::after': {
                                  content: '""',
                                  position: 'absolute',
                                  bottom: '8px',
                                  right: '-2px',
                                  width: '2px',
                                  height: 'calc(100% - 16px)',
                                  background: Palette.white,
                              },
                          },
                      }
                    : {}),
            },
        },
    };
};
